import React from 'react';
import { CareerStatus, PROFILE_SECTION_IDS } from '../constants';
import type { INotificationSetting } from '../interfaces';
import { SelectOptions } from '../../../utils/types/react_select_types';
import {
  AccountSection,
  CandidateSection,
  NotificationsSection,
  PersonalSection,
  PrivacySection,
} from '../components';

interface IProfileContentProps {
  activeSection: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  bio: string;
  jobTitle: string;
  profileLink: string;
  profilePicStatus: string;
  userInitials: string;
  userRole: string;
  isEditing: boolean;
  loading: boolean;
  isEmployee: boolean;
  jobTitleOptions: SelectOptions[];
  selectedJobTitle: SelectOptions | null;
  careerStatus: CareerStatus;
  notifications: INotificationSetting[];
  onFirstNameChange: (value: string) => void;
  onLastNameChange: (value: string) => void;
  onPhoneChange: (value: string) => void;
  onBioChange: (value: string) => void;
  onJobTitleChange: (option: SelectOptions | null) => void;
  onStartEdit: () => void;
  onSave: () => void;
  onCancel: () => void;
  onOpenPictureModal: () => void;
  onCareerStatusChange: (status: CareerStatus) => void;
}

export const ProfileContent = (props: IProfileContentProps) => {
  const { activeSection } = props;

  if (activeSection === PROFILE_SECTION_IDS.PERSONAL) {
    return (
      <PersonalSection
        firstName={props.firstName}
        lastName={props.lastName}
        email={props.email}
        phone={props.phone}
        bio={props.bio}
        jobTitle={props.jobTitle}
        profileLink={props.profileLink}
        profilePicStatus={props.profilePicStatus}
        userInitials={props.userInitials}
        isEditing={props.isEditing}
        loading={props.loading}
        isEmployee={props.isEmployee}
        jobTitleOptions={props.jobTitleOptions}
        selectedJobTitle={props.selectedJobTitle}
        onFirstNameChange={props.onFirstNameChange}
        onLastNameChange={props.onLastNameChange}
        onPhoneChange={props.onPhoneChange}
        onBioChange={props.onBioChange}
        onJobTitleChange={props.onJobTitleChange}
        onStartEdit={props.onStartEdit}
        onSave={props.onSave}
        onCancel={props.onCancel}
        onOpenPictureModal={props.onOpenPictureModal}
      />
    );
  }

  if (activeSection === PROFILE_SECTION_IDS.ACCOUNT) {
    return <AccountSection />;
  }

  if (activeSection === PROFILE_SECTION_IDS.NOTIFICATIONS) {
    return <NotificationsSection notifications={props.notifications} />;
  }

  if (activeSection === PROFILE_SECTION_IDS.PRIVACY) {
    return <PrivacySection />;
  }

  if (activeSection === PROFILE_SECTION_IDS.CANDIDATE && props.userRole === 'Candidate') {
    return (
      <CandidateSection
        careerStatus={props.careerStatus}
        onCareerStatusChange={props.onCareerStatusChange}
      />
    );
  }

  return null;
};
